<template>
    <div class="my-dashboard">
        <el-menu
            class="dashboard-menu"
            text-color="#fff"
            active-text-color="#fff"
            :default-active="activeIdx.toString()"
        >
            <el-menu-item
                v-for="(item, index) in menuItems"
                :key="index"
                :index="index.toString()"
                @click="item.click(item.route)"
            >
                <i :class="item.icon"></i>
                <span slot="title">{{item.title}}</span>
            </el-menu-item>
        </el-menu>
        <div class="my-dashboard-content">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
    name: "AdminDashboard",
    components: {
        // HelloWorld
    },
    data() {
        return {
            // menuItems:
        };
    },
    mounted() {
        this.loadPermissions();
    },
    watch: {
    },
    computed: {
        ...mapState({
            accessToken: state => state.accessToken,
            userInfo: state => state.userInfo,
            adminPerms: state => state.adminPerms,
        }),
        hasIdentificationStarted() {
            if (this.userInfo && this.userInfo.identification_type) {
                return true;
            }
            return false;
        },
        identification_type() {
            if (this.userInfo) {
                return this.userInfo.identification_type;
            }
            return null;
        },
        activeIdx() {
            let ctrl = this;
            return ctrl.menuItems.findIndex(menu => {
                return ctrl.$route.path.indexOf(menu.route) >= 0;
            });
        },
        menuItems() {
            let menus = [];
            if(this.adminPerms) {
                if(this.adminPerms.user && this.adminPerms.user.length > 0) {
                    if(this.adminPerms.user[0].visibility) {
                        menus.push({
                            title: "Identifications",
                            icon: "el-icon-user",
                            route: "/admin-dashboard/identification",
                            click: this.onMenuClick.bind(this)
                        });
                    }
                }
                if(this.adminPerms.user && this.adminPerms.user.length > 0) {
                    if(this.adminPerms.user[0].visibility) {
                        menus.push({
                            title: "User Address Book",
                            icon: "el-icon-s-management",
                            route: "/admin-dashboard/addressbook",
                            click: this.onMenuClick.bind(this)
                        });
                    }
                }
                if(this.adminPerms.user && this.adminPerms.user.length > 0) {
                    if(this.adminPerms.user[0].visibility) {
                        menus.push({
                            title: "User Bank Accounts",
                            icon: "el-icon-collection",
                            route: "/admin-dashboard/bankaccount",
                            click: this.onMenuClick.bind(this)
                        });
                    }
                }
                if(this.adminPerms.admin && this.adminPerms.admin.length > 0 && this.adminPerms.admin[0].visibility == 1) {
                    menus.push({
                        title: "Permission Settings",
                        icon: "el-icon-user-solid",
                        route: "/admin-dashboard/permission",
                        click: this.onMenuClick.bind(this)
                    });
                }
                if(this.adminPerms.currency && this.adminPerms.currency.length > 0) {
                    if(this.adminPerms.currency[0].visibility) {
                        menus.push({
                            title: "Currency Settings",
                            icon: "el-icon-setting",
                            route: "/admin-dashboard/currency",
                            click: this.onMenuClick.bind(this)
                        });
                    }
                }
                if(this.adminPerms.content && this.adminPerms.content.length > 0) {
                    if(this.adminPerms.content[0].visibility) {
                        menus.push({
                            title: "Site Contents",
                            icon: "el-icon-setting",
                            route: "/admin-dashboard/site_content",
                            click: this.onMenuClick.bind(this)
                        });
                    }
                }
                if(this.adminPerms.deposit && this.adminPerms.deposit.length > 0) {
                    if(this.adminPerms.deposit[0].visibility) {
                        menus.push({
                            title: "Deposits",
                            icon: "el-icon-money",
                            route: "/admin-dashboard/deposit",
                            click: this.onMenuClick.bind(this)
                        });
                    }
                }
                if(this.adminPerms.withdraw && this.adminPerms.withdraw.length > 0) {
                    if(this.adminPerms.withdraw[0].visibility) {
                        menus.push({
                            title: "Withdrawals",
                            icon: "el-icon-bank-card",
                            route: "/admin-dashboard/withdraw",
                            click: this.onMenuClick.bind(this)
                        });
                    }
                }
                if(this.adminPerms.transfer && this.adminPerms.transfer.length > 0) {
                    if(this.adminPerms.transfer[0].visibility) {
                        menus.push({
                            title: "Transfer",
                            icon: "el-icon-bank-card",
                            route: "/admin-dashboard/transfer",
                            click: this.onMenuClick.bind(this)
                        });
                    }
                }
                if(this.adminPerms.mint_burn && this.adminPerms.mint_burn.length > 0) {
                    if(this.adminPerms.mint_burn[0].visibility) {
                        menus.push({
                            title: "Mint & Burn",
                            icon: "el-icon-bank-card",
                            route: "/admin-dashboard/mint_burn",
                            click: this.onMenuClick.bind(this)
                        });
                    }
                }
                if(this.adminPerms.statistical && this.adminPerms.statistical.length > 0) {
                    if(this.adminPerms.statistical[0].visibility) {
                        menus.push({
                            title: "Statistics",
                            icon: "el-icon-s-data",
                            route: "/admin-dashboard/statistic",
                            click: this.onMenuClick.bind(this)
                        });
                    }
                }
            }
            // menus.push({
            //     title: "My Deposits", 
            //     icon: "el-icon-money", 
            //     route: "/admin-dashboard/my-deposit", 
            //     disabled:true, 
            //     click: this.onMenuClick.bind(this)
            // })
            return menus;
        }
    },
    methods: {
        ...mapActions([
            "request",
            "setAccessToken",
            "getError",
            "setAdminPerms"
        ]),
        redirect() {
            if(this.userInfo && this.adminPerms && this.adminPerms.exchange.length >= 0 && this.adminPerms.exchange[0].visibility == 1) {
                this.$router.push({ path: "/dashboard" });
            }
        },
        onMenuClick(path) {
            this.$router.push({ path });
        },
        loadPermissions() {
            let ctrl = this;
            ctrl.processing = true;
            let endpoint = `my/permission`;
            ctrl.request({
                method: "GET",
                endpoint
            })
                .then(({ data = {} }) => {
                    ctrl.setAdminPerms(data);
                    if(data.exchange.length >= 0 && data.exchange[0].visibility == 1) {
                        ctrl.$router.push({ path: "/dashboard" });
                    }
                })
                .catch(err => {
                    ctrl.setAdminPerms();
                    ctrl.getError({
                        err
                    }).then(ctrl.$notify);
                })
                .finally(() => {
                    setTimeout(() => {
                        ctrl.processing = false;
                    }, 500);
                });
        },
    }
};
</script>

<style scoped>
.el-menu-item.is-active {
    background-color:#016395;
}
.el-menu {
    height: 100%;
    background-color: #0070a9;
    border-right: solid 1px rgba(255, 255, 255, 0.15);
    width: 200px;
}
.el-menu-item:focus,
.el-menu-item:hover {
    outline: 0;
    background-color: rgba(0, 0, 0, 0.3);
}
.my-dashboard {
    width: 100%;
    height: 100%;
    display: flex;
}
.my-dashboard-content {
    flex: 1;
    overflow: auto;
}
.identification-badge-dot {
    width: 100%;
}
</style>
<style>
.identification-badge-dot .is-dot {
    left: 150px;
    top: 16px;
}
</style>
